import { ReactNode } from "react";
import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  slots: { base: "!text-mobile-h4 md:!text-h4" },
  variants: {
    color: {
      white: "text-white",
      primary: "text-primary",
      secondary: "text-secondary",
    },
  },
  defaultVariants: {
    color: "secondary",
  },
});

interface IProps {
  children: ReactNode;
  color?: VariantProps<typeof styles>["color"];
  className?: string;
  testId?: string;
}

const H4 = ({ children, className, color, testId }: IProps) => {
  const { base } = styles({ color, className });

  return (
    <h4 data-testid={testId} className={base({ className })}>
      {children}
    </h4>
  );
};

export default H4;
